import React, { useState } from 'react';
import { connect } from 'react-redux';
import serialize from 'serialize-javascript';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { setCookie, getCookie } from '../../utilities/helpers';
import TranslatedCopy from '../../intl/translated-copy';
import Btn from '../global/button';
import RadioButton from '../global/radio-button';
import {
  setFlowCorporateIsActive,
  setCompanySelected,
  setCorporateSupplierSelected,
  closeModalCorporate,
  loginCorporate,
  retrieveCorporateProfileUserAction,
} from '../../../redux/actions/index';
import manageTracking from '../../../scripts/analytics/creators/manage';
import { sendAnalytics } from '../../../scripts/analytics/tracker';
import { trackRegToCorp } from '../../../scripts/analytics/creators/corporate';

const mapStateToProps = state => ({
  corporate: state.Corporate,
  changeSwitchFlowCorporate: state.Corporate.changeSwitchFlowCorporate,
  isActiveFlowCorporate: state.Corporate.isActiveFlowCorporate,
  isSignIn: state.UserProfileSession.isSignIn,
  language: state.Manage.language,
  pnrInfo: state.Manage.pnrInfo,
  storeFront: state.Manage.storefront,
  userCorporate: state.Corporate.userCorporate,
  userProfile: state.UserProfileSession,
  user: state.UserProfileSession,
});

const ModalCorporateFlow = (props) => {
  const { 
    dispatch,
    openCorporateModal,
    userCorporate,
    userProfile,
  } = props;

  const [activeSelect, setActiveSelect] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [companySelectedModal, setCompanySelectedModal] = useState('PRO_SELECT_MODAL');
  const [radioSelected, setRadioSelected] = useState('');
  const [showSelect, setShowSelect] = useState(false);
  const name = userProfile && userProfile?.userFirstName;
  const ffNumber = userProfile?.userProfile?.ffNumber;
  const isCompanys = userCorporate?.companies;
  const companysArray = isCompanys ? isCompanys?.getCompanies() : [];
  const companyDefaultSelected = companysArray.length === 1 && companysArray[0].name;
  const isDisabledCompanyPreselect = companySelectedModal === 'PRO_SELECT_MODAL';
  const corporateRadioButton = radioSelected === 'corporate' ? true : false;
  const companySelectName = companySelectedModal;
  const classSelect = cx ({
    'BookerSelect-button': true,
    'UserProfile-Corporate-Select': true,
    'is-active': activeSelect,
  });

  const classListSelect = cx ({
    'UserProfile-Corporate-Select-List': true,
    'is-active': activeSelect,
  });

  openCorporateModal();

  const getSelectCompanies = () =>{
    return (
      <>
      <div className='UserProfile-Corporate-Select-Content'>
        <TranslatedCopy className='UserProfile-Corporate-Select-Label' copyID='PRO_SELECT_LOGIN' />
        <button
          className={ classSelect }
          id='select'
          onClick={ () => handleSelect(activeSelect) }
        >
          <TranslatedCopy  copyID={ companySelectName } />
          <span className='Icon Icon--arrowSmallDown arrowIsHomeBooker'></span>
        </button>
        { activeSelect &&
          <div className={ classListSelect }>
            { getListCompanys() }
          </div>
        }
      </div>
      </>
    );
  };

  const getListCompanys = () => {
    return companysArray.map((company, i ) => {
      return (
        <div
          className='UserProfile-Corporate-Select-List-Item'
          key={ i }
          onClick={ () => handleSelectCompany(company.name) }
        >
          { company.name }
        </div>
      );
    });
  };

  const renderModalHeader = (
    <section className='UserProfile-Corporate-Header'>
      <section className='UserProfile-Corporate-info'>
        <TranslatedCopy
          className='UserProfile-Corporate-headerName'
          copyID='PRO_CORPORATE_HEADER_HELLO'
          tagName='h3'
        />
        <h3 className='UserProfile-Corporate-headerName'>
          { name }
        </h3>
      </section>
      <section className='UserProfile-Corporate-info'>
        <TranslatedCopy 
          copyID='CORP_PRO_MODAL_FFNUMBER'
          tagName='p'
        />
        <strong className='UserProfile-Corporate-ffnumber'>No. { ffNumber } </strong>
      </section>
    </section>
  );

  const renderModalBody  = (
    <section className='UserProfile-Corporate-Body'>
      <TranslatedCopy
        className='UserProfile-Corporate-Text'
        copyID='PRO_SELECT_PROFILE'
        tagName='p'
      />
      <div>
        <div className='UserProfile-Corporate-Option flex'>
          <RadioButton
            isActive={ radioSelected === 'personal' }
            isDisabled={ false }
            onClick={ () => validateFormSelected('personal', companysArray) }
            option={ 1 }
            optionIndex={ 1 }
          />
          <TranslatedCopy
            className='UserProfile-Corporate-txtRadioButtons'
            copyID='PRO_CORPORATE_SELECT_PERSONAL'
            tagName='p'
          />
        </div>
        <div className='UserProfile-Corporate-Option'>
          <div className='flex'>
            <RadioButton
              isActive={ radioSelected === 'corporate' }
              isDisabled={ false}
              onClick={ () => validateFormSelected('corporate', companysArray) }
              option={ 2 }
              optionIndex={ 2 }
            />
            <div className='UserProfile-Corporate-logoConcurModal'>
              <TranslatedCopy
                className='UserProfile-Corporate-txtRadioButtons'
                copyID='PRO_CORPORATE_MODAL'
                tagName='p'
              />
            </div>
          </div>
          { showSelect && companysArray.length > 1 && getSelectCompanies() }
        </div>
        <Btn
          btnType='submit'
          className='UserProfile-Corporate-Btn'
          copyID='APP_SAVE'
          disabled={ buttonDisabled }
          filledRed={ true }
          onBtnClick={ () => handleSubmit() }
          visuallyDisabled={ buttonDisabled }
        />
      </div>
    </section>
  );

  const renderModalFooter = (
    <div className='UserProfile-Corporate-Footer'>
      <TranslatedCopy
        copyID='PRO_PREMIERPOINTS_MODAL'
        tagName='p'
      />
    </div>
  );


  function validateFormSelected(experienceSelect, companys) {
    if (experienceSelect === 'personal') {
      setButtonDisabled(false);
      setCompanySelectedModal('PRO_SELECT_MODAL');
      setRadioSelected(experienceSelect);
      setShowSelect(false);
    }

    if (experienceSelect === 'corporate') {
      if (companys.length > 1) {
        setButtonDisabled(isDisabledCompanyPreselect);
        setCompanySelectedModal('PRO_SELECT_MODAL');
        setRadioSelected(experienceSelect);
        setShowSelect(true);
      } else {
        setButtonDisabled(false);
        setCompanySelectedModal(companyDefaultSelected);
        setRadioSelected(experienceSelect);
      }
    }
  }

  function handleSelectCompany(companySelect) {
    setButtonDisabled(false);
    setCompanySelectedModal(companySelect);
    setRadioSelected('corporate');
    setActiveSelect(false);
  }

  function handleSelect(activeSelect) {
    setButtonDisabled(companySelectedModal === 'PRO_SELECT_MODAL');
    setRadioSelected('corporate');
    setActiveSelect(!activeSelect);
  }

  
  function handleSubmit() {
    let objectCookie = {};
    if ( corporateRadioButton ) {
      const supplier = 'nutravel';
      const company = corporateRadioButton ? companySelectedModal !== 'PRO_SELECT_MODAL' ? companySelectedModal : userCorporate.companies.getNameCompany() : '';
      dispatch(setFlowCorporateIsActive(true));
      dispatch(setCompanySelected(company));
      dispatch(setCorporateSupplierSelected(supplier));
      localStorage.setItem('companySelected', company);
      localStorage.setItem('corporateSupplierSelected', supplier);
      localStorage.setItem('userIsCorporate', true);
      objectCookie = { ...objectCookie, companySelected: company, CorporateSupplier: supplier, isUserCorporate: true };
      setCookie('userSessionCorporate', serialize(objectCookie));
      handleCorporateLoginInfo(supplier);
      handleCorporateMetrics();
    } else {
      dispatch(setFlowCorporateIsActive(false));
      localStorage.setItem('userIsCorporate', false);
    }
    localStorage.setItem('experienceSelect', radioSelected);
    dispatch(closeModalCorporate());
    onCloseModal({ isLoginCorporate: corporateRadioButton });
  }

  function onCloseModal({ isLoginCorporate = false }) {
    const htmlTag = document.getElementsByTagName('html')[0];

    htmlTag.classList.remove('Modal-open--state');
    if (localStorage.hasOwnProperty('position')) {
      const position = localStorage.getItem('position');
      window.scrollTo(0, position);
    }
    dispatch(loginCorporate(isLoginCorporate));
  }

  function handleCorporateLoginInfo(supplier) {
    const {
      country,
      language,
    } = props;

    const pos = {
      'store': country,
      'pos': 'WEB',
      'language': language,
      'isCorporateFlow': true,
      'corporateName': supplier,
    };
    const userSession = getCookie('userSession');
    const _token = JSON.parse(userSession).userToken;
    dispatch(retrieveCorporateProfileUserAction(_token, pos)); 
  }

  function handleCorporateMetrics() {
    const {
      pnrInfo,
      storeFront,
      user,
      changeSwitchFlowCorporate,
    } = props;

    const subFunnelNameUserProperty = 'Manage my Booking';
    dispatch(sendAnalytics({
      eventCreator: manageTracking.trackuserPropertiesWeb(pnrInfo, user?.userProfile, subFunnelNameUserProperty, storeFront, { isSwitchCorporate: true }),
    }));
    /**
     * @changeSwitchFlowCorporate
     * Used to avoid triggering the metric when logged in
     */
    if (changeSwitchFlowCorporate) {
      const subFunnelNameRegToCorp = 'Itinerary';
      dispatch(sendAnalytics({
        eventCreator: trackRegToCorp(subFunnelNameRegToCorp),
      }));
    }
  }

  return (
    <div className='modal-Corporate'>
      <div className='Modal-inner-Corporate'>
        <div className='Modal-body-login Modal-body--isOpen Modal-body--regular has-noDefaultTopBar' tabIndex='0'>
          <div className='UserProfile-Corporate'>
            { renderModalHeader }
            { renderModalBody }
            { renderModalFooter }
          </div>
        </div>
      </div>
    </div>
  );
};

ModalCorporateFlow.propTypes = {
  userProfile: PropTypes.object.isRequired,
  userCorporate: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  openCorporateModal: PropTypes.func.isRequired,
};


export default connect(mapStateToProps)(ModalCorporateFlow);